module.exports = __webpack_public_path__ + "img/help.fb53bc97.svg";